import { Realty, services } from '@ambita/ambita-components-core';
import { TagInterface } from 'riot';
import { i18nMixin, I18nMixin } from '../i18nMixin';
import { getBrokerLetterReportData } from '../../actions/brokerLetterReport';
import { getAddressFromOwner } from '../../services/cadastreReport';
import * as brokerLetterReportConstants from '../../constants/brokerLetterReport';
import brokerLetterReportStore from '../../stores/brokerLetterReport';

const { util } = services;
const { events: brokerLetterReportEvents } = brokerLetterReportConstants;

export interface BrokerLetterReportTag extends TagInterface, I18nMixin {
  data: any;
  loading: boolean;
  opts: {
    propertyKey: string;
    onTaskDone(): void;
  };
  getAddressFromOwner(owner: Realty.ApiPerson): string;
}

export const init = (tag: BrokerLetterReportTag): void => {
  tag.mixin(i18nMixin);

  const setReportDataLoading = (): void => {
    tag.loading = true;
    tag.update();
  };

  const finishLoadingAndSetTaskDone = (): void => {
    tag.loading = false;
    tag.update();

    if (util.isFunction(tag.opts.onTaskDone)) {
      tag.opts.onTaskDone();
    }
  };

  const setReportDataLoaded = (): void => {
    tag.data = brokerLetterReportStore.getReportData();
    finishLoadingAndSetTaskDone();
  };

  const setReportDataFailed = (): void => {
    finishLoadingAndSetTaskDone();
  };

  tag.getAddressFromOwner = getAddressFromOwner;

  tag.on('mount', (): void => {
    brokerLetterReportStore.on(brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_LOADING, setReportDataLoading);
    brokerLetterReportStore.on(brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_LOADED, setReportDataLoaded);
    brokerLetterReportStore.on(brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_FAILED, setReportDataFailed);

    getBrokerLetterReportData(tag.opts.propertyKey);
  });

  tag.on('unmount', (): void => {
    brokerLetterReportStore.off(brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_LOADING, setReportDataLoading);
    brokerLetterReportStore.off(brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_LOADED, setReportDataLoaded);
    brokerLetterReportStore.off(brokerLetterReportEvents.BROKER_LETTER_REPORT_DATA_FAILED, setReportDataFailed);
  });
};
